import { Link } from "react-router-dom";
import { useAdminMode } from "../adminMode";
import AuthMenu from "../../auth/components/AuthMenu";
import MaterialIcon from "./MaterialIcon";

/** The header of every page but the player: the brand linking home, About, the library (and Admin, for admins with admin tools on), and sign-in. */
export default function TopBar() {
  const { unlocked } = useAdminMode();
  return (
    <header className="topbar">
      <nav className="topbar-nav">
        <Link to="/" className="brand">
          <img src="/icons/favicon-64.png" alt="" className="brand-icon" />
          <strong>CloudBoy</strong>
        </Link>
        <Link to="/about" className="btn icon-btn about-link" aria-label="About" data-tip="About">
          <MaterialIcon name="info" />
        </Link>
        <Link to="/library" className="btn">
          Library
        </Link>
        {unlocked && (
          <Link to="/admin" className="btn">
            Admin
          </Link>
        )}
      </nav>
      <AuthMenu />
    </header>
  );
}
